//@flow
import {useSelector} from 'react-redux';

import {actions as accountActions} from '../duck';

import type {RootState} from '../../../index';
import type {Collaborator} from '../../../../entities';
import {useRef, useEffect} from 'react';
import {useActions} from '../../../../utils/globalStore';

const collaboratorsSelector = (state: RootState) => ({
  collaborators: state.accountsConfig.collaborators || [],
  isLoading: state.accountsConfig.isFetching,
});

export function useCollaborators(): {
  collaborators: Collaborator[],
  isLoading: boolean,
} {
  const {collaborators, isLoading} = useSelector(collaboratorsSelector);

  return {collaborators, isLoading};
}

const MAX_RETRIES = 2;

export function useInitializeCollaborators() {
  const {collaborators, isLoading} = useCollaborators();

  const getCollaborators = useActions(accountActions.fetchCollaborators);

  const retriesCount = useRef(0);

  useEffect(() => {
    if (collaborators.length > 0) return;
    if (retriesCount.current >= MAX_RETRIES) return;

    retriesCount.current += 1;
    getCollaborators();
  }, [collaborators.length, getCollaborators]);

  return {collaborators, isLoading};
}
